import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
// import axios from "axios";
import api from "../../utils/api";
import { API_CALL_STATUS } from "../../assets/constants/constants";
import { toggleSavePost, uploadPostPicture, deletePostPicture } from "../post/postSlice";
api.defaults.withCredentials = true;

const initialState = {
  status: API_CALL_STATUS.IDLE,
  userInfo: {},
  userAddressDetails: {}, //current address object
  userGeoLocation: {},
  geoStatus: API_CALL_STATUS.IDLE,
  profilePic: "",   //user profile picture
  homeImages: [],  //user home pictures
  error: null,
};

export const getUserDetails = createAsyncThunk(
  "user/user-details",
  async (userData, { rejectWithValue }) => {
    try {
      const response = await api.get("/user/user-details");
      return response.data;
    } catch (error) {
      if (!error.response) {
        throw error;
      }
      return rejectWithValue(error.response.data);
    }
  }
);
export const UpdateUserDetails = createAsyncThunk(
  "user/update-user-details",
  async (userData, { rejectWithValue }) => {
    try {
      const response = await api.patch("/user/update-user-details", userData);
      return response.data;
    } catch (error) {
      if (!error.response) {
        throw error;
      }
      return rejectWithValue(error.response.data);
    }
  }
);

// async thunk for signing out
export const signOut = createAsyncThunk(
  "user/signOut",
  async (userData, { rejectWithValue }) => {
    try {
      const response = await api.post("/user/signout");
      return response.data;
    } catch (error) {
      if (!error.response) {
        throw error;
      }
      return rejectWithValue(error.response.data);
    }
  }
);

// async thunk for save user resident details (img excluded)-------------
export const SaveUserAddressObject = createAsyncThunk(
  "user/saveUserAddressObject",
  async (userData, { rejectWithValue }) => {
    try {
      const response = await api.post("/resident-info/save-current-address", userData);
      return response.data;
    } catch (error) {
      if (!error.response) {
        throw error;
      }
      return rejectWithValue(error.response.data);
    }
  }
);

export const getUserAddressObject = createAsyncThunk(
  "user/getUserAddressObject",
  async (userData, { rejectWithValue }) => {
    try {
      const response = await api.post("/resident-info/get-current-address");


      return response.data;
    } catch (error) {
      if (!error.response) {
        throw error;
      }
      return rejectWithValue(error.response.data);
    }
  }
);
export const saveUserProfilePic = createAsyncThunk(
  "user/saveUserProfilePic",
  async (userData, { rejectWithValue }) => {
    try {
      const response = await api.post("/upload/profile-picture", userData, { headers: { 'Content-Type': 'multipart/form-data' } });
      return response.data;
    } catch (error) {
      if (!error.response) {
        throw error;
      }
      return rejectWithValue(error.response.data);
    }
  }
);
export const deleteUserProfilePic = createAsyncThunk(
  "user/deleteUserProfilePic",
  async (userData, { rejectWithValue }) => {
    try {
      const response = await api.delete("/upload/delete-profile-picture");
      return response.data;
    } catch (error) {
      if (!error.response) {
        throw error;
      }
      return rejectWithValue(error.response.data);
    }
  }
);

const userSlice = createSlice({
  name: "user",
  initialState,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [],
      },
    }),
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(signOut.pending, (state) => {
        state.status = API_CALL_STATUS.LOADING;
      })
      .addCase(signOut.fulfilled, (state) => {
        state.status = API_CALL_STATUS.IDLE;
        state.userInfo = {};
        state.error = null;
        state.profilePic = "";
      })
      .addCase(signOut.rejected, (state, action) => {
        state.status = API_CALL_STATUS.FAILED;
        state.error = action.payload || "Something went wrong...";
      })
      .addCase(getUserDetails.pending, (state) => {
        state.status = API_CALL_STATUS.LOADING;
      })
      .addCase(getUserDetails.fulfilled, (state, action) => {
        state.userInfo = action.payload.data;
        state.profilePic = action.payload.profilePic
        state.status = API_CALL_STATUS.SUCCEEDED;
      })
      .addCase(getUserDetails.rejected, (state, action) => {
        state.status = API_CALL_STATUS.FAILED;
        state.error = action.payload || "Something went wrong...";
      })
      .addCase(toggleSavePost.fulfilled, (state, action) => {
        state.userInfo = action.payload.data;
        state.status = API_CALL_STATUS.SUCCEEDED;
      })
      .addCase(UpdateUserDetails.pending, (state) => {
        state.status = API_CALL_STATUS.LOADING;
      })
      .addCase(UpdateUserDetails.fulfilled, (state, action) => {
        state.userInfo = action.payload.data;
        state.status = API_CALL_STATUS.SUCCEEDED;
      })
      .addCase(UpdateUserDetails.rejected, (state, action) => {
        state.status = API_CALL_STATUS.FAILED;
        state.error = action.payload || "Something went wrong...";
      })
      .addCase(SaveUserAddressObject.pending, (state) => {
        state.status = API_CALL_STATUS.LOADING;
      })
      .addCase(SaveUserAddressObject.fulfilled, (state, action) => {
        state.userAddressDetails = action.payload.data.currentLocation;
        state.userGeoLocation = action.payload.data.userGeoLocation || state.userGeoLocation;
        state.status = API_CALL_STATUS.SUCCEEDED;
      })
      .addCase(SaveUserAddressObject.rejected, (state, action) => {
        state.status = API_CALL_STATUS.FAILED;
        state.error = action.payload || "Something went wrong...";
      })
      .addCase(getUserAddressObject.pending, (state) => {
        state.geoStatus = API_CALL_STATUS.LOADING;
      })
      .addCase(getUserAddressObject.fulfilled, (state, action) => {
        state.userAddressDetails = action.payload.data.currentLocation;
        state.homeImages = action.payload.data.homePictures;
        state.userGeoLocation = action.payload.data.userGeoLocation || state.userGeoLocation;
        state.geoStatus = API_CALL_STATUS.SUCCEEDED;
      })
      .addCase(getUserAddressObject.rejected, (state, action) => {
        state.geoStatus = API_CALL_STATUS.FAILED;
        state.error = action.payload || "Something went wrong...";
      })
      .addCase(saveUserProfilePic.pending, (state) => {
        state.status = API_CALL_STATUS.LOADING;
      })
      .addCase(saveUserProfilePic.fulfilled, (state, action) => {
        state.profilePic = action.payload.profilePic;
        state.status = API_CALL_STATUS.SUCCEEDED;
      })
      .addCase(saveUserProfilePic.rejected, (state, action) => {
        state.status = API_CALL_STATUS.FAILED;
        state.error = action.payload || "Something went wrong...";
      })
      .addCase(deleteUserProfilePic.pending, (state) => {
        state.status = API_CALL_STATUS.LOADING;
      })
      .addCase(deleteUserProfilePic.fulfilled, (state, action) => {
        state.profilePic = action.payload.profilePic;
        state.status = API_CALL_STATUS.SUCCEEDED;
      })
      .addCase(deleteUserProfilePic.rejected, (state, action) => {
        state.status = API_CALL_STATUS.FAILED;
        state.error = action.payload || "Something went wrong...";
      })
      .addCase(uploadPostPicture.fulfilled, (state, action) => {
        state.status = API_CALL_STATUS.SUCCEEDED;
        state.error = null;
        state.homeImages = action.payload.data.residentInfo.homePictures;
      })
      .addCase(deletePostPicture.fulfilled, (state, action) => {
        state.status = API_CALL_STATUS.SUCCEEDED;
        state.homeImages = action.payload.data.remainingPictures;
      })
  },
});

export default userSlice.reducer;
